<div class="drawer-form-wrapper">
  <form nz-form class="form" nzLayout="horizontal">
    <div class="form-grid-secondary">
      <nz-form-item class="col-span">
        <nz-form-label nzFor="title">Title</nz-form-label>
        <nz-form-control nzErrorTip="Please input your user name.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="title"
            formControlName="title"
            placeholder="Enter title" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-form-label nzFor="administratorNote">
          Administrator Note
        </nz-form-label>
        <nz-form-control nzErrorTip="Please input administrator note.">
          <textarea
            id="administratorNote"
            name="administratorNote"
            rows="4"
            nz-input
            placeholder="Enter your text"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-form-label nzFor="description">Description </nz-form-label>
        <nz-form-control nzErrorTip="Please input your user name.">
          <textarea
            id="description"
            name="description"
            rows="4"
            nz-input
            placeholder="Enter your text"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <span nz-checkbox formControlName="autoAssign">Auto Assign</span>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="type">Type</nz-form-label>
        <nz-form-control nzErrorTip="Please input your type.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select type"
            [nzOptionOverflowSize]="7">
            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="type">Skill Level</nz-form-label>
        <nz-form-control nzErrorTip="Please input your skill level.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select skill level"
            [nzOptionOverflowSize]="7">
            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="duration">Duration (Mins) </nz-form-label>
        <nz-form-control nzErrorTip="Please input duration.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="duration"
            formControlName="duration"
            placeholder="Enter duration" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="author">Author(s)</nz-form-label>
        <nz-form-control nzErrorTip="Please input author.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="author"
            formControlName="author"
            placeholder="Enter author" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="presenter">Presenter(s)</nz-form-label>
        <nz-form-control nzErrorTip="Please input presenter.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="presenter"
            formControlName="presenter"
            placeholder="Enter presenter" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="audience">Audience</nz-form-label>
        <nz-form-control nzErrorTip="Please input audience.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select audience"
            [nzOptionOverflowSize]="7">
            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-form-label nzFor="maxTimePerSlide"
          >Max Time Per Slide (mins)</nz-form-label
        >
        <nz-form-control nzErrorTip="Please input max tiume per slide.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="maxTimePerSlide"
            formControlName="maxTimePerSlide"
            placeholder="Enter max time per slide" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-upload nzListType="picture" class="file-upload">
          <nz-form-label nzFor="maxTimePerSlide">Upload Workshop</nz-form-label>
          <button nz-button type="button">
            <div class="upload-icon">
              <svg-icon
                src="/assets/icon/icon-upload.svg"
                class="icon s-12"></svg-icon>
            </div>
            <div class="wrapper">
              <p class="text s-14 fw-600 green">
                Click to upload
                <span class="text s-14 fw-400">or drag and drop</span>
              </p>
              <p class="text s-12 fw-400">XLS or CSV files only</p>
            </div>
          </button>
        </nz-upload>
        <div class="btn-wrapper-end">
          <button
            type="button"
            nz-button
            nzType="text"
            class="primary-text-btn">
            Sample Import File
          </button>
        </div>
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-upload nzListType="picture" class="file-upload">
          <nz-form-label nzFor="maxTimePerSlide">Upload Quiz</nz-form-label>
          <button nz-button type="button">
            <div class="upload-icon">
              <svg-icon
                src="/assets/icon/icon-upload.svg"
                class="icon s-12"></svg-icon>
            </div>
            <div class="wrapper">
              <p class="text s-14 fw-600 green">
                Click to upload
                <span class="text s-14 fw-400">or drag and drop</span>
              </p>
              <p class="text s-12 fw-400">XLS or CSV files only</p>
            </div>
          </button>
        </nz-upload>
        <div class="btn-wrapper-end">
          <button
            type="button"
            nz-button
            nzType="text"
            class="primary-text-btn">
            Sample Import File
          </button>
        </div>
      </nz-form-item>
      <nz-form-item class="col-span">
        <span nz-checkbox formControlName="sendEmail">
          Send email notification (including optional details below)</span
        >
      </nz-form-item>
      <nz-form-item class="col-span">
        <nz-form-control nzErrorTip="Please input your user name.">
          <textarea
            id="description"
            name="description"
            rows="4"
            nz-input
            placeholder="Enter your text"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="col-span">
        <div class="form-table">
          <div class="table-header">
            <h2 class="title s-18">Learning Objectives</h2>
            <button nz-button nzType="primary" type="button">
              Add Objective
            </button>
          </div>
          <nz-table
            [nzData]="listOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false">
            <thead>
              <tr>
                <th nzWidth="20%">Sequence</th>
                <th nzWidth="70%">Objectives</th>
                <th nzWidth="100px">Action</th>
              </tr>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="drop($event)">
              @for (data of listOfData; track data) {
                <tr cdkDrag>
                  <td nzWidth="20%" class="drag-point">
                    <span>
                      <button nz-button nzType="text">
                        <svg-icon
                          src="/assets/icon/icon-drag.svg"
                          class="icon s-20"></svg-icon>
                      </button>
                      {{ data.sequence }}
                    </span>
                  </td>
                  <td nzWidth="70%">
                    <textarea
                      [value]="data.objectives"
                      rows="2"
                      nz-input
                      placeholder="Enter your text"></textarea>
                  </td>
                  <td nzWidth="100px">
                    <button nz-button type="button" nzType="text">
                      <svg-icon
                        src="/assets/icon/icon-trash.svg"
                        class="icon s-20"></svg-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-form-item>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button nzType="default">Cancel</button>
      <button nz-button nzType="primary">Add</button>
    </div>
  </form>
</div>
